import { roundNumber } from './common';

export function Investments(capacities_increase) {
    if(capacities_increase > 0) {
        return capacities_increase * 10
    }
    return 0
}

export function ResearchCosts(segments) {
    
    if (segments.length > 0) {
        const res =  segments.reduce((sum, segment) => {
            return sum+= segment.max_price
        }, 0)
        return roundNumber(res * 17, 2);
    }
    return 0;
}

export function Interests(long_term_debt, borrowings) {
    return roundNumber((long_term_debt + borrowings) * 0.07, 2);
}